module.exports = __webpack_public_path__ + "img/dlbg.f504ae41.png";